import { createSelector } from '@reduxjs/toolkit';
const callObjectRoot = state => state.callObject;
export const callObjectIdSelector = createSelector(callObjectRoot, ({
  callObjectId
}) => callObjectId);
export const callObjectTitleSelector = createSelector(callObjectRoot, ({
  callObjectTitle
}) => callObjectTitle);
export const isLoadingSelector = createSelector(callObjectRoot, ({
  isLoading
}) => isLoading);